const services = ['bubblechat', 'tingle'] as const satisfies readonly string[];
export type ServiceName = (typeof services)[number];

export const serviceName: ServiceName = (import.meta.env.VITE_APP_SERVICE_NAME as ServiceName) || 'bubblechat';

export const languages = ['en', 'ko', 'th', 'zh', 'ja'] as const satisfies readonly string[];
export type Languages = (typeof languages)[number];

/**
 * 언어별 로케일 지연 로더 — 브랜드×언어 JSON 10개(raw 2.5MB)를 정적 import 하던 것을
 * 개별 청크 동적 로드로 바꿔 초기 정적 폐쇄에서 제거한다(초기 번들 축소 P1).
 * vite 가 glob(locales 하위 locale-*.json 전체)으로 청크를 만들고, 런타임엔 현재 브랜드의
 * 요청 언어만 페치된다. 소비처는 i18n 의 지연 로딩 backend(chat-service constant/i18n) 단일.
 */
export const loadLocaleResource = (lng: Languages): Promise<Record<string, string>> =>
  import(`./locales/${serviceName}/locale-${lng}.json`).then((m) => m.default);
